<template>
  <div class="container">
    <div class="order-number">
      <div class="table-top">
        <div>
          采购计划编号：
          <el-button type="text" @click="handleCodeDetail(records)">
            {{ records.purchasePlanCode }}
          </el-button>
        </div>
        <!-- {{ item.purchaseDemandCode }} -->
        <div>采购计划名称：{{ records.purchasePlanName }}</div>
        <div class="approver">创建人：{{ records.creteName }}</div>
        <div class="order-status-text">创建时间：{{ records.createTime }}</div>
        <div v-if="routeData.type == 'agreement'">
          协议编号：
          <el-button type="text" @click="handleAgreementCode(records)">
            {{ records.protocolCode }}
          </el-button>
        </div>
      </div>
      <ETableList
        :table-data="records.planItemVOList"
        :show-header="false"
        index-show
        :table-label="tableLabel"
      >
        <template #categoryDesc="{ scope }">
          <div>
            <div class="item-desc">物料描述</div>
            <div class="item-content">{{ scope.row.categoryDesc }}</div>
          </div>
        </template>
        <template #baseUnitName="{ scope }">
          <div>
            <div class="item-desc">计量单位</div>
            <div class="item-content">{{ scope.row.baseUnitName }}</div>
          </div>
        </template>
        <template #goodsInfo="{ scope }">
          <div class="goods-info">
            <div class="goods-info-wrapper">
              <div class="item-goodsImg">
                <!--  v-lazy="skuItem.purchasePlanItemSkuVOList[0].productImageUrl" -->
                <img
                  v-if="scope.row.purchasePlanItemSkuVOList"
                  class="goodsImg"
                  :src="scope.row.purchasePlanItemSkuVOList[0].productImageUrl"
                  alt=""
                />
              </div>
              <div class="item-img">
                <div class="item-img-content">
                  <div
                    v-if="scope.row.purchasePlanItemSkuVOList"
                    class="item-img-content-top"
                  >
                    <div class="item-img-content-row" style="margin-left: 10px">
                      <div
                        class="item-img-content-column"
                        style="margin-bottom: 12px"
                      >
                        <div class="item-img-content-name in2clamp">
                          {{
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuName
                          }}
                        </div>
                        <el-tooltip
                          v-if="
                            scope.row.purchasePlanItemSkuVOList &&
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuName &&
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuName.length > 110
                          "
                          class="item"
                          effect="dark"
                          :content="
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuName
                          "
                          placement="top"
                        >
                          <div class="font break">
                            <div class="font break">
                              {{
                                scope.row.purchasePlanItemSkuVOList[0]
                                  .productSkuName
                              }}
                            </div>
                          </div>
                        </el-tooltip>
                      </div>

                      <div class="item-img-content-column">
                        <div
                          v-if="
                            scope.row.purchasePlanItemSkuVOList &&
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuCode.length <= 38
                          "
                          class="item-img-content-name"
                          style="color: #999999; line-height: 1"
                        >
                          商品编码：{{
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuCode
                          }}
                        </div>
                        <el-tooltip
                          v-if="
                            scope.row.purchasePlanItemSkuVOList &&
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuCode &&
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuCode.length > 38
                          "
                          class="item"
                          effect="dark"
                          :content="
                            scope.row.purchasePlanItemSkuVOList[0]
                              .productSkuCode
                          "
                          placement="top"
                        >
                          <div
                            class="item-img-content-name in3clamp"
                            style="color: #999999; line-height: 1"
                          >
                            商品编码：{{
                              scope.row.purchasePlanItemSkuVOList[0]
                                .productSkuCode
                            }}
                          </div>
                        </el-tooltip>
                      </div>
                      <!-- <div class="item-img-content-row">
                      <div
                        class="item-img-content-column"
                        v-if="scope.row.purchasePlanItemSkuVOList"
                      >
                        <div
                          class="item-img-btn editProduct"
                          @click="handleSelectProduct(scope.row)"
                        >
                          修改商品
                        </div>
                      </div>
                    </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style="margin: 3px 0 0 7px">
              <eui-btn
                v-if="scope.row.purchasePlanItemSkuVOList"
                type="text"
                @click="handleSelectProduct(scope.row)"
              >
                修改商品
              </eui-btn>
            </div>
          </div>

          <div class="change-btn">
            <eui-btn
              v-if="!scope.row.purchasePlanItemSkuVOList"
              @click="handleSelectProduct(scope.row)"
            >
              选择商品
            </eui-btn>
          </div>
        </template>
        <template #quantity="{ scope }">
          <div>
            <div class="item-desc">采购数量</div>
            <div class="item-content">{{ scope.row.quantity }}</div>
          </div>
        </template>
        <template #handle="{ scope }">
          <div class="center-btn">
            <eui-btn type="text" @click="handleDelete(scope.row)">删除</eui-btn>
          </div>
        </template>
      </ETableList>
    </div>

    <div class="button-handle">
      <eui-btn type="secondary" @click="handleCancel">取 消</eui-btn>
      <eui-btn @click="handleOrder">生成订单</eui-btn>
    </div>

    <ChooseGoodsDialog
      v-if="visible"
      :visible.sync="visible"
      :route-data="routeData"
      :records="records"
      :purchase-row="purchaseRow"
      @getOrderList="getOrderList"
    ></ChooseGoodsDialog>

    <!-- <eDialog
      :dialog-title="dialogTitle"
      :show-btn="false"
      :center-dialog-visible="visible"
      :popup-width="'800px'"
      @updateVisible="visible = false"
      @resetPopupData="visible = false"
      @submitPopupData="submitPopupData"
    >
      <el-form ref="form" class="form" :model="productSearch" :inline="true">
        <el-form-item label="供应商名称：">
          <el-input v-model="productSearch.suppliercompanyname" style="width: 150px; height: 30px"></el-input>
        </el-form-item>
        <el-form-item label="商品名称：">
          <el-input v-model="productSearch.skuname" style="width: 150px; height: 30px"></el-input>
        </el-form-item>
        <el-form-item label="商品编码：" prop="proportion">
          <el-input v-model="productSearch.skucode" style="width: 150px; height: 30px"></el-input>
        </el-form-item>
      </el-form>
      <div class="button-handle" style="margin-top: -10px">
        <div class="reset" style="width: 80px; height: 30px; line-height: 30px" @click="handleReset">重置</div>
        <div class="query" style="width: 80px; height: 30px; line-height: 30px" @click="handleSearch">查询</div>
      </div>
      <ESearch
        :data="queryData"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></ESearch>

      <div class="request-table" style="margin-top: 10px">
        <ul class="request-table-row">
          <li class="request-table-column" style="width: 280px">商品信息</li>
          <li class="request-table-column" style="width: 110px; border-left: 1px solid #dcdcdc">品牌</li>
          <li class="request-table-column" style="width: 100px; border-left: 1px solid #dcdcdc">发货时间</li>
          <li class="request-table-column" style="width: 80px; border-left: 1px solid #dcdcdc">单位</li>
          <li class="request-table-column" style="width: 110px; border-left: 1px solid #dcdcdc">含税价格（元）</li>
          <li class="request-table-column" style="width: 100px; border-left: 1px solid #dcdcdc">操作</li>
        </ul>
      </div>
      <div
        v-if="routeData.type == 'agreement'"
        class="request-table"
        style="overflow: auto; height: 382px; padding-bottom: 10px"
      >
        <ul
          v-for="(item, index) in tableData"
          :key="index"
          class="request-table-row"
          style="height: 93px; background: #ffffff; border-top: 0 !important"
        >
          <li
            class="request-table-column"
            style="width: 280px; display: flex; align-items: flex-start; margin-top: 8px"
          >
            <div class="product-info">
              <img class="product-img" :src="item.defaultimage" alt />
              <div class="product-info-right">
                <div v-if="item.skuname.length < 48" class="title two-line">
                  {{ item.skuname }}
                </div>
                <el-tooltip v-else class="item" effect="dark" :content="item.skuname" placement="top">
                  <div class="title two-line">{{ item.skuname }}</div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="item.skucode" placement="bottom">
                  <div class="num break">单品编号：{{ item.skucode }}</div>
                </el-tooltip>
                <div v-if="item.suppliercompanyname.length < 11" class="provider">
                  供应商：{{ item.suppliercompanyname }}
                </div>
                <el-tooltip v-else class="item" effect="dark" :content="item.suppliercompanyname" placement="top">
                  <div class="provider break">供应商：{{ item.suppliercompanyname }}</div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li class="request-table-column" style="width: 110px">
            {{ item.brandname }}
          </li>
          <li class="request-table-column" style="width: 100px">{{ item.delivertime }}天内发货</li>
          <li class="request-table-column" style="width: 80px">
            {{ item.unitvalue }}
          </li>
          <li class="request-table-column" style="width: 110px; color: #f0250f">
         {{ '￥' + item.price }}
            <span
              v-if="
                item.price > 0 &&
                (item.pricetypedescribe !== undefined ||
                  item.pricetypedescribe === undefined) &&
                item.pricetypedescribe !== '惠享价'
              "
              style="color: #f0250f; font-weight: bold"
            >
              ￥{{ Number(item.price).toFixed(2) }}
            </span>
            <span
              v-if="
                item.price > 0 &&
                item.pricetypedescribe != undefined &&
                item.pricetypedescribe === '惠享价'
              "
              style="color: #f0250f; font-weight: bold"
            >
              ￥{{ Number(item.shareprice).toFixed(2) }}
            </span>
          </li>
          <li class="request-table-column" style="width: 100px">
            <div class="button-handle">
              <div class="query" style="width: 80px; height: 30px; line-height: 30px" @click="handleSelected(item)">
                选中
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else class="request-table" style="overflow: auto; height: 382px; padding-bottom: 10px">
        <ul
          v-for="(item, index) in tableData"
          :key="index"
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="busy"
          infinite-scroll-immediate="false"
          infinite-scroll-distance="0"
          class="request-table-row"
          style="height: 93px; background: #ffffff; border-top: 0 !important"
        >
          <li
            class="request-table-column"
            style="width: 280px; display: flex; align-items: flex-start; margin-top: 8px"
          >
            <div class="product-info">
              <img class="product-img" :src="item.defaultimage" alt />
              <div class="product-info-right">
                <div v-if="item.skuname.length < 48" class="title two-line">
                  {{ item.skuname }}
                </div>
                <el-tooltip v-else class="item" effect="dark" :content="item.skuname" placement="top">
                  <div class="title two-line">{{ item.skuname }}</div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="item.skucode" placement="bottom">
                  <div class="num break">单品编号：{{ item.skucode }}</div>
                </el-tooltip>
                <div v-if="item.suppliercompanyname.length < 11" class="provider">
                  供应商：{{ item.suppliercompanyname }}
                </div>
                <el-tooltip v-else class="item" effect="dark" :content="item.suppliercompanyname" placement="top">
                  <div class="provider break">供应商：{{ item.suppliercompanyname }}</div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li class="request-table-column" style="width: 110px">
            {{ item.brandname }}
          </li>
          <li class="request-table-column" style="width: 100px">{{ item.delivertime }}天内发货</li>
          <li class="request-table-column" style="width: 80px">
            {{ item.unitvalue }}
          </li>
          <li class="request-table-column" style="width: 110px; color: #f0250f">
            {{ '￥' + item.price }}
          </li>
          <li class="request-table-column" style="width: 100px">
            <div class="button-handle">
              <div class="query" style="width: 80px; height: 30px; line-height: 30px" @click="handleSelected(item)">
                选中
              </div>
            </div>
          </li>
        </ul>
      </div>
      <el-pagination
        v-if="routeData.type == 'agreement'"
        style="margin-top: 20px"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="productSearch.pageNum"
        :total="productTotal"
        :page-size.sync="productSearch.pageSize"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleProductCurrentChange"
      ></el-pagination>
    </eDialog> -->
  </div>
</template>
<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import ESearch from '@/modules/projectA/components/common/e-search';
import ETableList from '@/modules/projectA/components/common/e-table-list';

import Api from '@/modules/projectA/api/purchase/index';
import { orderBaseUrl } from '@/modules/projectA/api/config';
import ChooseGoodsDialog from './chooseGoodsDialog.vue';

let rowLeftNum = '';
function validatePurchaseNum(rule, value, callback) {
  console.log('value', value);
  console.log('rule', rule);
  if (!value || value == 0) {
    return callback(new Error('请输入采购数量'));
  }

  if (rowLeftNum && value > rowLeftNum) {
    return callback(new Error('采购数量小于等于剩余采购数量'));
  }
  callback();
}
export default {
  name: 'AllOrder',
  components: { eDialog, ETableList, ESearch, ChooseGoodsDialog },
  props: {
    changeOrderHandle: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      tipWord: '',
      checkCompanyAttrFlag: false,
      dialogType: '',
      dialogTitle: '选择商品',
      isDoc: '',
      dialogContent: '',
      visible: false,
      underlineName: '',
      underlineOrderId: '',
      orderStatusNum: '',
      onLinePayAndCompanyPay: '', // 在线支付与担保支付组合
      loading: true,
      noDataFlag: false,
      resData: {},
      formInline: {
        projectnos: null, // 采购申请号 目前没有
        orderNo: null, // 订单编号
        supplierCompany: null, // 供应商名称
        time: null,
        startTime: null,
        endTime: null,
        memberRealName: null, // 下单人姓名
        shipmentType: null, // 配送方式 1：配送　　2：自提
        orderStatus: null,
        otherPay: 0, // 0不使用1使用易权通
        endAmount: null,
        startAmount: null,
        pageNum: 1,
        pageSize: 5,
      },
      records: [],
      form: {},
      tableData: [],
      rules: {
        purchaseNum: [{ validator: validatePurchaseNum, trigger: ['blur'] }],
      },
      count: 1,
      busy: true,
      productSearch: {
        skuname: '', // 精确查
        skucode: '', // 商品编号
        suppliercompanyname: '', // 供应商
        pageNum: 1,
        pageSize: 10,
      },
      isFixed: true,
      purchaseRow: {},
      taxInfo: {},
      routeData: null,
      productTotal: 0,
      tableLabel: [
        {
          label: '物料描述',
          slot: 'categoryDesc',
          minWidth: 240,
        },

        {
          label: '计量单位',
          slot: 'baseUnitName',
          minWidth: 88,
        },
        {
          label: '商品信息',
          slot: 'goodsInfo',
          minWidth: 314,
        },
        {
          label: '采购数量',
          slot: 'quantity',
          minWidth: 88,
        },
        {
          label: '操作',
          slot: 'handle',
          minWidth: 60,
          align: 'center',
        },
      ],

      queryData: {
        purchasePlanName: '',
        purchasePlanCode: '',
        createTime: '',
        submitTimeStart: '',
        submitTimeEnd: '',
        purchaseModeType: null,
        pageNum: 1,
        pageSize: 10,
      },
      fieldList: [
        {
          label: '采购计划名称',
          type: 'input',
          value: 'purchasePlanName',
        },
        {
          label: '采购计划编号',
          type: 'input',
          value: 'purchasePlanCode',
        },
        {
          label: '提交时间',
          type: 'date',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          dateType: 'daterange',
        },
        {
          label: '采购计划',
          type: 'select',
          placeholder: '请选择',
          value: 'purchaseModeType',
          list: 'purchaseModeTypeList',
        },
      ],
      listTypeInfo: {
        purchaseModeTypeList: [
          { name: '选品下单', id: 1 },
          { name: '询比价', id: 2 },
          { name: '自行招标', id: 3 },
          { name: '委托招标', id: 4 },
          { name: '执行框架协议', id: 5 },
        ],
      },
    };
  },
  created() {
    this.routeData = this.$route.query;
    this.selectOrder();
    this.getOrderList();
  },
  mounted() {
    // this.checkShow();
    // window.addEventListener('scroll', this.initHeight);
  },
  /* destroyed() {
    window.removeEventListener('scroll', this.initHeight);
  }, */
  methods: {
    // 详情
    handleCodeDetail(row) {
      const { purchasePlanId } = row;
      this.$router.push({
        path: `/plan/purchaseQuery/purchaseDetail`,
        query: { purchasePlanId },
      });
    },
    handleAgreementCode(row) {
      this.$router.push({
        path: `/demand/execute/agreementDetail`,
        query: { agreementId: row.protocolId || '' },
      });
    },
    initHeight() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // scrollTop = scrollTop+634;
      // console.log(scrollTop, '这是scrollTop');
      // let height =  document.documentElement.clientHeight || document.body.clientHeight;
      // let scorllHeight =  document.body.scrollHeight  ||document.documentElement.scrollHeight;
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      // console.log(height, 'height');
      const div = document.getElementById('show-btn');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      if (scrollTop + height < divToTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    checkShow() {
      const div = document.getElementById('show-btn');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (height + scrollTop > divToTop) {
        this.isFixed = false;
      } else {
        this.isFixed = true;
      }
    },
    // 查询
    async selectOrder() {
      const params = {
        ...this.productSearch,
      };
      const res = await Api.queryProductPage2(params);
      if (res.code == '200') {
        this.tableData = this.tableData.concat(res.data.list); // 数组拼接，得到拼接后的数据
        this.total = res.data.list.length;
        if (res.data.list.length == 0 && this.routeData.type != 'agreement')
          this.busy = true;
        else this.busy = false;
      } else {
        this.$message.error(res.message);
      }
    },

    loadMore() {
      this.busy = true;
      // 把busy置位true，这次请求结束前不再执行
      setTimeout(() => {
        // 订单列表
        this.productSearch.pageNum = this.count++;
        this.busy = true;
        this.selectOrder();
        // 调用获取数据接口，并且传入一个true，让axios方法指导是否需要拼接数组。
      }, 500);
    },
    handleEditProduct(item) {
      this.purchaseRow = item;
      this.visible = true;
    },
    handleCancel() {
      this.$router.back();
    },
    handleOrder() {
      // window.open(
      //   `${purchaseUrl}/order?flag=purchasePlan&purchasePlanId=${this.routeData.purchasePlanId}`,
      //   '_blank'
      // );
      window.open(`${orderBaseUrl}/order?from=v&flag=purchasePlan&purchasePlanId=${this.routeData.purchasePlanId}`, '_blank');

    },
    handleReset() {
      this.productSearch.skuname = '';
      this.productSearch.skucode = '';
      this.productSearch.suppliercompanyname = '';
    },
    async handleSearch() {
      this.productSearch.pageNum = 1;
      const res = await Api.queryProductPage2({
        ...this.productSearch,
      });
      if (res.code == '200') {
        this.tableData = res.data.list; // 数组拼接，得到拼接后的数据
        if (res.data.list.length == 0) this.busy = true;
        else this.busy = false;
      } else {
        this.$message.error(res.message);
      }
    },
    handleSelectionChange() {},
    async handleSelected(val) {
      const userInfo = this.$store.state.USERINFO;
      // 获得税率信息
      const param = {
        taxRateId: val.taxrateid,
      };
      const res1 = await Api.getProductRate(param);

      if (res1.code == '200') {
        this.taxInfo = res1.data;

        const params = {
          brandName: val.brandname, // 品牌
          categoryId: val.categoryid, // 商品类目ID
          categoryName: val.category, // 商品类目名称
          price: val.price, // this.getAddCartPrice(val), // 商品价格
          productId: val.productid, // 商品id
          productImageUrl: val.defaultimage, // 商品图片
          productSkuCode: val.skucode, // 货品编号
          productSkuId: val.skuid, // 货品ID
          productSkuName: val.skuname, // 商品名称
          productSkuOptions: val.specificationsList, // 规格字符串 数组
          productSkuOptionsStr: val.specificationstr, // 规格字符串 拼接
          conversionUnitRatio: '', // 计量单位转换比率
          salesTaxNo: this.taxInfo.taxRateCode, // 销售税码
          salesTaxRate: this.taxInfo.taxRate, // 销售税率
          supplierCompanyId: val.suppliercompanyid, // 供应商公司id
          supplierCompanyName: val.suppliercompanyname, // 供应商公司名称
          purchaseCompanyId: this.routeData.purchaseCompanyId, // 采购商id
          purchaseCompanyName: this.routeData.purchaseCompanyName, // 采购商名称
          unitName: val.unitvalue, // 商品计量单位名称
          createMemberId: userInfo.memberId, // 申请人ID
          createMemberName: userInfo.memberName, // 申请人真实姓名
          createTime: this.records.createTime, // 创建时间
          protocolCode: this.records.protocolCode, // 协议编码
          protocolId: this.records.protocolId, // 协议ID
          purchasePlanId: this.routeData.purchasePlanId, // 采购计划id
          purchasePlanItemId: this.purchaseRow.purchasePlanItemId, // 采购计划物料明细id
          purchaseQuantity: this.purchaseRow.quantity, // 采购数量
          subtotal: this.purchaseRow.quantity * val.price, // 小计
          unitCode: '', // 商品计量单位编码
          purchasePlanItemSkuId: val.skuid, // 采购计划商品明细id
          deleteStatus: '', // 删除标记 默认 0：有效 1：删除
          updateMemberId: userInfo.memberId, // 申请人ID
          updateMemberName: userInfo.memberName, // 申请人真实姓名
          updateTime: '', // 修改时间
        };
        const res = await Api.checkPlanItemSku(params);
        if (res.code === '200') {
          this.visible = false;
          this.getOrderList();
        }
      }
    },
    getAddCartPrice(options) {
      let addCartPrice = null;
      if (
        options.pricetypedescribe !== undefined &&
        options.pricetypedescribe === '惠享价'
      ) {
        addCartPrice = options.shareprice;
      } else {
        addCartPrice = options.price;
      }
      return addCartPrice;
    },
    handleSelectProduct(item) {
      this.purchaseRow = item;
      // 如果是框架协议
      if (this.routeData.type === 'agreement') {
        // this.queryEpecPriceByPage();
        this.visible = true;
      } else {
        // this.visible = true;
        this.$router.push({
          path: '/plan/purchaseWayExecute/selectGoods',
          query: {
            purchasePlanItemId: item.purchasePlanItemId,
            type: this.routeData.type,
            purchasePlanId: item.purchasePlanId,
          },
        });
      }
    },

    async queryEpecPriceByPage() {
      const params = {
        agreementId: this.records.protocolId,
        skuname: this.productSearch.skuname, // 精确查
        skucode: this.productSearch.skucode, // 商品编号
        supplierCompanyName: this.productSearch.suppliercompanyname,
        pageSize: 10,
        pageNum: this.productSearch.pageNum,
        supplierCompanyId: this.records.supplierCompanyId,
      };
      const res = await Api.queryEpecPriceByPage(params);
      if (res.code === '200') {
        const skuIds = res.data.records.map((item) => item.skuId);
        if (skuIds.length) {
          this.productTotal = res.data.total;
          this.queryProductPage2Data(skuIds);
        } else {
          this.tableData = [];
          this.visible = true;
        }
      }
    },

    async queryProductPage2Data(skuIds) {
      const params = {
        pageNum: 1,
        pageSize: 10,
        skuIds,
      };
      const res = await Api.queryProductPage2(params);
      this.tableData = [...res.data.list];
      this.visible = true;
    },

    async handleInput(row) {
      rowLeftNum = row.remainingQuantity;
    },
    handleBlur() {
      rowLeftNum = '';
    },
    submitPopupData() {},
    async getOrderList() {
      const params = {
        purchasePlanId: this.$route.query.purchasePlanId,
      };
      const res = await Api.purchasePlanPlanExecute(params);
      this.records = res.data;
      localStorage.setItem(
        'purchaseWayExecuteRecords',
        JSON.stringify(this.records)
      );
    },
    async handleDelete(val) {
      const params = {
        purchasePlanItemId: val.purchasePlanItemId,
      };
      const res = await Api.deletePurchasePlanItem(params);
      if (res.code == '200') {
        this.$message.success('删除成功');
        this.getOrderList();
      }
    },
    async getRateInfo(val) {
      const params = {
        taxRateId: val,
      };
      const res = await Api.getProductRate(params);

      if (res.code == '200') {
        this.taxInfo = res.data;
        console.log('this.taxInfo', this.taxInfo);
      }
    },
    async handleNumChange(val, skuItem) {
      // 调接口将采购数据传给订单11/14
      const params = {
        purchaseDemandItemSkuId: skuItem.purchaseDemandItemSkuId,
        purchaseQuantity: val.purchaseNum,
      };
      const res = await Api.queryPurchaseNum(params);
    },
  },
};
</script>
<style lang="scss">
.el-tooltip__popper {
  border-radius: 0;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
::v-deep .el-table {
  .el-table__cell {
    height: 110px;
  }
  .cell {
    height: 100%;
    text-align: left;
    .item-desc {
      color: #999;
      line-height: 1;
    }
    .item-content {
      margin-top: 6px;
    }
    .center-btn {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .change-btn {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.order-number {
  background: #fff;
  .margin-b10 {
    margin-bottom: 10px;
  }
  .table-top {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    height: 40px;
    color: #333;
    font-weight: bold;
    line-height: 40px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f5f5f5;
    border: 1px solid $border-color;
    box-sizing: border-box;
    font-size: 12px;
    .top-header-left {
      color: #333333;
      font-weight: 700;
      display: flex;
    }
    .top-header-right {
      display: flex;
      justify-items: center;
      .approver {
        display: flex;
        span {
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .order-status-text {
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 20px;
        .img-show {
          width: 18px;
          height: 18px;
          margin-left: 10px;
          background: url('~@/assets/img/purchase/help-gray.png') center
            no-repeat;
          background-size: 18px 18px;
          &:hover {
            background: url('~@/assets/img/purchase/help-gray-active.png')
              center no-repeat;
            background-size: 18px 18px;
          }
        }
      }
    }
  }
  .middle-view {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid $border-color;
    border-top: none;
    height: 115px;
    .item-index {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
    }
    .item-desc::-webkit-scrollbar {
      display: none;
    }

    .item-desc {
      height: 100%;
      border-left: 1px solid $border-color;
      width: 270px;
      padding: 20px;
      box-sizing: border-box;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      font-size: 14px;
      line-height: 18px;
      overflow-y: scroll;
      color: #999999;
      .item-desc-content {
        width: 200px;
      }
    }
    .item-goodsImg {
      display: flex;
      align-items: center;
      justify-content: center;
      /* border-left: 1px solid $border-color; */
      width: 100px;
      height: 100%;
      .goodsImg {
        width: 60px;
        height: 60px;
        display: block;
        border-left: 1px solid $border-color;
      }
    }
    .item-unit {
      display: flex;
      align-items: center;
      border-left: 1px solid $border-color;
      padding: 20px;
      width: 170px;
      height: 100%;
      .item-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 142px;
        .item-row-column {
          display: flex;
          flex-direction: column;
          .item-row-column-desc {
            font-size: 14px;
            line-height: 14px;
            display: flex;
            align-items: center;
            color: #999999;
          }
          .item-row-column-content {
            font-size: 14px;
            line-height: 14px;
            color: #333333;
            margin-top: 8px;
            margin-bottom: 8px;
          }
        }
      }
    }
    .item-img {
      border-left: 1px solid $border-color;
      height: 100%;
      display: flex;
      align-items: center;
      .item-img-content {
        .item-img-content-top {
          display: flex;
          align-items: flex-start;

          .item-img-content-row {
            display: flex;
            font-size: 14px;
            flex-direction: column;

            .item-img-content-column {
              line-height: 1;
              .item-img-btn {
                font-size: 14px;
                line-height: 14px;
                color: #0064c8;
                margin-top: 10px;
                text-align: center;
              }
              .editProduct {
                font-size: 14px;
                line-height: 14px;
                color: #0064c8;
                margin-top: 10px;
                text-align: center;
                cursor: pointer;
              }
              .img-relative {
                width: 70px;
                height: 70px;
              }
              .img-absolute {
                width: 20px;
                height: 25px;
                position: absolute;
                left: 6px;
                top: 0;
              }
              .item-img-content-name {
                font-size: 14px;
                line-height: 20px;

                color: #333333;
              }
            }
            li:nth-child(2) {
              margin: 0 10px;
            }
            li:nth-child(3) {
              margin-right: 10px;
            }
          }
        }
        .item-img-content-bottom {
          display: flex;
          margin-top: 18px;
          color: #999;
          font-size: 12px;
          .real-name {
            width: 92px;
          }
          .phone {
            width: 139px;
          }
          .dept {
            width: 236px;
          }
          .break {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span:nth-child(2) {
            margin: 0 10px;
          }
        }
      }
      .query {
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #2587ff;
        color: #ffffff;
        margin-left: 100px;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
    .item-name {
      display: flex;
      align-items: center;
      border-left: 1px solid $border-color;
      height: 100%;
      box-sizing: border-box;
      width: 160px;
      justify-content: center;
      .item-name-nick {
        color: #999999;
        margin-bottom: 10px;
      }
      .item-name-nick:before {
        content: '* ';
        color: red;
        vertical-align: middle;
        display: inline-block;
      }
      ::v-deep .el-input__inner {
        height: 30px;
        border-radius: 0 !important;
      }
      ::v-deep .el-form-item__label {
        padding: 0px 0 0px;
        line-height: 1;
      }
      ::v-deep .el-form-item {
        margin-bottom: 0 !important;
      }
      ::v-deep .el-form-item__error {
        padding-top: 0px;
      }
    }
    .item-detail {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-left: 1px solid $border-color;
      height: 100%;
      box-sizing: border-box;
      width: 113px;
      font-size: 14px;
      color: #0064c8;
      .is-active {
        border-bottom: 1px solid #0064c8;
      }
      div {
        cursor: pointer;
        color: #0064c8;
        border-bottom: 1px solid transparent;
        &:hover,
        :active {
          color: #2782ec;
          border-bottom: 1px solid #0064c8;
        }
      }

      .active {
        color: #2782ec;
      }
    }
  }
  .bottom-view {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    border: 1px solid $border-color;
    border-top: none;

    .bottom-view-left {
      font-weight: 400;
      color: #333;
      span {
        margin-left: 40px;
      }
      .more {
        color: #2f80ed;
        margin-left: 10px;
        cursor: pointer;
      }

      ::v-deep .el-tooltip_popper {
        width: 30px;
      }
    }
    .bottom-view-right {
      font-size: 14px;
      color: #999999;
    }
  }
  .no-data {
    text-align: center;
    margin-bottom: 80px;
    img {
      margin-top: 60px;
      width: 204px;
      height: 124px;
    }
    p {
      margin-top: 10px;
      color: #333;
      font-size: 16px;
      span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
}

.goods-info {
  .goods-info-wrapper {
    display: flex;
    align-items: center;
    .item-goodsImg {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .goodsImg {
        width: 70px;
        height: 70px;
        display: block;
        border: 1px solid $border-color;
      }
    }
    .item-img {
      display: flex;
      align-items: center;
      .item-img-content {
        .item-img-content-top {
          display: flex;
          align-items: flex-start;

          .item-img-content-row {
            height: 70px;
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            flex-direction: column;

            .item-img-content-column {
              line-height: 1;
              .item-img-btn {
                font-size: 12px;
                line-height: 12px;
                color: #0064c8;
                margin-top: 10px;
                text-align: center;
              }
              .editProduct {
                font-size: 12px;
                line-height: 12px;
                color: #0064c8;
                margin-top: 10px;
                text-align: center;
                cursor: pointer;
              }
              .img-relative {
                width: 70px;
                height: 70px;
              }
              .img-absolute {
                width: 20px;
                height: 25px;
                position: absolute;
                left: 6px;
                top: 0;
              }
              .item-img-content-name {
                font-size: 12px;
                line-height: 20px;

                color: #333333;
              }
            }
            li:nth-child(2) {
              margin: 0 10px;
            }
            li:nth-child(3) {
              margin-right: 10px;
            }
          }
        }
        .item-img-content-bottom {
          display: flex;
          margin-top: 18px;
          color: #999;
          font-size: 12px;
          .real-name {
            width: 92px;
          }
          .phone {
            width: 139px;
          }
          .dept {
            width: 236px;
          }
          .break {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span:nth-child(2) {
            margin: 0 10px;
          }
        }
      }
      .query {
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #2587ff;
        color: #ffffff;
        margin-left: 100px;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }
}
.img-relative[lazy='error'] {
  width: 70px !important;
  height: 70px !important;
}
.product-img[lazy='error'] {
  width: 50px !important;
  height: 50px !important;
}
.button-handle {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.form ::v-deep .el-input__inner {
  height: 30px;
  border-radius: 0 !important;
}

::v-deep .el-dialog__body {
  padding: 10px 10px;
}

.request-table {
  .request-table-row {
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border: 1px solid #dcdcdc;
    .request-table-column {
      height: 100%;
      text-align: center;
      font-size: 14px;
      color: #333333;
      display: flex;
      justify-content: center;
      align-items: center;
      .product-info {
        position: relative;
        display: flex;
        /* align-items: center; */
        width: 280px;
        margin-left: 10px;
        .product-img {
          width: 50px;
          height: 50px;
          border: 1px solid #e2e2e2;
          box-sizing: border-box;
        }

        .product-img-icon {
          position: absolute;
          top: 11px;
          left: 6px;
          width: 20px;
          height: 20px;
        }

        .product-info-right {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .two-line {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          > div {
            align-self: flex-start;
          }

          .title {
            width: 208px;
            text-align: left;
            color: #333333;
            line-height: 1;
            margin-bottom: 10px;
          }

          .num {
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 208px;
            font-size: 14px;
            line-height: 14px;
            text-align: left;
          }

          .provider {
            font-size: 14px;
            color: #666666;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 208px;
          }

          .footer {
            display: flex;
            justify-content: flex-start;

            p {
              width: 48px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              color: #ffffff;
              margin-left: 10px;
              border-radius: 5px;
              font-size: 14px;
            }

            .authenticated {
              background-color: $button-background-color;
            }

            .easy-all-pass {
              background-color: $button-background-color2;
            }
          }
        }
      }
    }
  }
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3);
    cursor: pointer;
  }
}
</style>
